import { mapActions, mapGetters } from 'vuex';
import storage_init from '../storage/grapes-init';
const juice = require('juice');
let scrollPage = 20;
import mixin from '../mixins/Mixin.js';
import mixinTranslate from '../mixins/GrapesMixinTranslate';
import * as durationHelper from '../helpers/duration-handler';

import i18n from '../i18n';
import en from '../i18n/en_US';
import fr from '../i18n/fr_FR';
export default {
  mixins: [mixin, mixinTranslate],
  i18n: {
    messages: {
      en,
      fr,
    },
  },
  computed: {
    ...mapGetters({
      imageWidth: 'common/getImageWidth',
      parentWidth: 'common/getParentWidth',
      someImage: 'common/getSomeImage',
      getCurrentSlideIndex: 'slides/getCurrentSlideIndex',
      getSelected: 'slides/getSelected',
      getSelectedSegments: 'segments/getSelectedSegments',
      getCurrentSegment: 'segments/getCurrent',
      getCurrentSlide: 'slides/getCurrent',
      currentSlide: 'slides/getCurrent',
      paramsClient: 'getParamsClients',
      showIconSave: 'common/getShowIconSave',
      hasPermission: 'hasPermission',
      getSegmentByUid: 'segments/getByUid',
      ListSvgObject: 'common/getListSvgObject',
    }),

    setMoveAttr() {
      return {
        class: 'fa fa-arrows',
        title: this.$i18n.t('tooltips.move'),
        draggable: true,
      };
    },
    setDuplicateAttr() {
      return {
        class: 'fa fa-clone',
        title: this.$i18n.t('tooltips.duplicate'),
      };
    },
    setRemoveAttr() {
      return { class: 'fa fa-trash-o', title: this.$t('tooltips.delete') };
    },
    setSettingsAttr() {
      return { class: 'fa fa-cogs', title: this.$t('tooltips.setting') };
    },
    setEditAttr() {
      return { class: 'fa fa-paint-brush', title: this.$t('tooltips.edit') };
    },
  },

  methods: {
    ...mapActions('slides', [
      'setDelayFragment',
      'setOpacityFragment',
      'updateSlide',
      'updateSlideDuration',
      'setCurrentSlide',
    ]),
    ...mapActions('common', [
      'setDeviceType',
      'setDeviceSize',
      'setParentWidth',
      'setSomeImage',
      'setShowIconSave',
      'duplicateSvgObject',
    ]),
    ...mapActions('segments', ['updateSlideInsideSegment', 'appendBlankSlideToSegment']),
    udpdateClocksFontSize(editor, model) {
      let classes = model.getClasses();
      let cssComposer = editor.CssComposer;
      let css = cssComposer.getClassRule(classes[0]);
      if (classes && classes[0]) {
        let oldStyle = css && css.attributes ? css.attributes.style : {};
        let fontSizeModel = oldStyle['font-size']
          ? oldStyle['font-size']
          : window.getComputedStyle(model.view.el).fontSize;
        const iframeEl = document.querySelector('.gjs-cv-canvas .gjs-frame');

        let fontVw;
        if (fontSizeModel.indexOf('vw') > -1) {
          fontVw = parseFloat(fontSizeModel);
        } else {
          fontVw =
            (100 * parseFloat(fontSizeModel)) / parseFloat(window.getComputedStyle(iframeEl).width);
        }

        let width = fontVw * (10 / 0.5) + '%';
        let newStyle = Object.assign({}, oldStyle, { width });

        cssComposer.setClassRule(classes[0], newStyle);
      }
    },
    udpdateClocksWidthHeight(editor, model) {
      let classes = model.getClasses();
      let cssComposer = editor.CssComposer;
      let css = cssComposer.getClassRule(classes[0]);
      if (classes && classes[0]) {
        let oldStyle = css && css.attributes ? css.attributes.style : {};
        let widthModel =
          oldStyle.width && oldStyle.width !== 'auto'
            ? oldStyle.width
            : window.getComputedStyle(model.view.el).width;
        let heightModel =
          oldStyle.height && oldStyle.height !== 'auto'
            ? oldStyle.height
            : window.getComputedStyle(model.view.el).height;

        const iframeEl = document.querySelector('.gjs-cv-canvas .gjs-frame');

        if (widthModel.indexOf('px') > -1) {
          const width =
            (parseFloat(widthModel) / parseFloat(window.getComputedStyle(iframeEl).width)) * 100 +
            '%';

          let newStyle = Object.assign({}, oldStyle, { width });
          cssComposer.setClassRule(classes[0], newStyle);
          widthModel = width;
        }

        if (heightModel.indexOf('px') > -1) {
          const height =
            (parseFloat(heightModel) / parseFloat(window.getComputedStyle(iframeEl).height)) * 100 +
            '%';

          let newStyle = Object.assign({}, oldStyle, { height });
          cssComposer.setClassRule(classes[0], newStyle);
        }

        let fontSize = (parseFloat(widthModel) / 10) * 0.5;
        let fontnew = fontSize + 'vw';
        let newStyle = Object.assign({}, oldStyle, { 'font-size': fontnew });
        cssComposer.setClassRule(classes[0], newStyle);
      }
    },
    toastDelete(editor) {
      let selected = editor.getSelected();
      if (!selected || !selected.get('removable')) {
        console.warn('The element is not removable', selected);
      } else if (selected) {
        selected.destroy();
        var iconSave = document.querySelector('.icon-save');
        this.$toasted.show("L'élément sélectionné est supprimé", {
          theme: 'bubble',
          position: 'top-center',
          duration: 4000,
          action: [
            {
              text: 'Annuler',
              onClick: (e, toastObject) => {
                const wrapper = document.querySelector('.gjs-frame').contentWindow.document;
                const um = editor.UndoManager;
                const stacks = um.getStack().models;
                const id = selected.view.el.id;
                const countClass = selected.view.el.classList[0];
                const type = selected.attributes.type;
                window.um = um;
                if (stacks.length > 0) {
                  let i = stacks.length - 1;
                  let found = false;
                  if (id) {
                    while (i > 0 && !found) {
                      // if (type === 'social-icons-weather') {
                      //   selected.set('deleted', true);
                      // }
                      editor.UndoManager.undo();
                      if (type === 'custom-countdown') {
                        found = !!wrapper.querySelector('.' + countClass + '#' + id);
                      } else {
                        found = !!wrapper.getElementById(id);
                      }
                      i--;
                    }
                  } else {
                    editor.UndoManager.undo();
                  }
                  iconSave.classList.add('icon-selected');
                  this.setShowIconSave(true);
                }
                setTimeout(() => {
                  const lastSlide = {
                    uid: this.currentSlide.uid,
                    components: localStorage.getItem('gjs-components'),
                    js: localStorage.getItem('gjs-js'),
                    html: localStorage.getItem('gjs-html'),
                    css: this.sanitizeCSS(localStorage.getItem('gjs-css')),
                    styles: localStorage.getItem('gjs-styles'),
                  };
                  if (this.$route.name === 'segment') {
                    this.updateSlide(lastSlide);
                  } else {
                    this.updateSlideInsideSegment(lastSlide);
                  }
                  this.$root.$emit('updateCanvasContent');
                }, 100);

                toastObject.goAway(0);
              },
            },

            {
              icon: 'fa-times',
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              },
            },
          ],
        });

        if (iconSave) {
          iconSave.classList.add('icon-selected');
          this.setShowIconSave(true);
        }
      }
    },
    generateId(model) {
      var text = 'i';
      var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      for (var i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      return text;
    },
    eventStorageLoad(editor) {
      // Store and load events
      editor.on('storage:load', function(e) {
        console.log('storage:load', e);
      });
    },
    eventStorageStart(editor) {
      // Store and load events
      editor.on('storage:start', function(e) {
        console.log('storage:start', e);
      });
    },
    eventStorageStartStore(editor) {
      // Store and load events
      editor.on('storage:start:store', function(e) {
        console.log('storage:start:store', e);
      });
    },
    eventStorageEnd(editor) {
      editor.on('storage:end', function(e) {
        console.log('storage:end', e);
      });
    },
    eventStorageEndStore(editor) {
      var self = this;
      if (this.$route.name === 'edit') {
        let firstCall = 0;
        editor.on('storage:end:store', e => {
          var iconSave = document.querySelector('.icon-save');
          if (iconSave && firstCall < 2) {
            firstCall++;
            iconSave.classList.remove('icon-selected');
            self.setShowIconSave(false);
          }
        });
      }
      editor.on('storage:end:store', e => {
        this.handleLocalStorage();
      });
    },
    handleLayersPanel(editor, iteration = 0) {
      const layers = document.querySelectorAll(
        '.gjs-pn-views-container > div > .gjs-layer > .gjs-layer-children > .gjs-layers > .gjs-layer',
      );
      if (!layers && iteration < 10) {
        setTimeout(() => {
          this.handleLayersPanel(editor, iteration++);
        }, 10);
      }
      const models = editor.getComponents().models;
      let index = 0;
      layers.forEach(el => {
        const i = index++;
        let toggler = el.querySelector('[data-toggle-visible]');
        this.initializeLayer(el, models[i], editor);
        toggler.onmouseup = () => {
          setTimeout(() => {
            this.handleUpdateStyle(models[i], editor);
          }, 100);
        };
      });
    },
    initializeLayer(layer, model, editor) {
      const cssComposer = editor.CssComposer;
      let classes = model.getClasses();
      let style =
        cssComposer.getClassRule(classes[0]) && cssComposer.getClassRule(classes[0]).attributes
          ? cssComposer.getClassRule(classes[0]).attributes.style
          : {};
      if (layer.innerHTML.includes('Box') && model.attributes.type === '') {
        layer.style.display = 'none';
      }
      if (!this.hasPermission.sort_layers_action) {
        layer.querySelector('.fa-arrows').style.display = 'none';
      }
      if (style.display && style.display === 'none') {
        let toggler = layer.querySelector('[data-toggle-visible]');
        toggler.click();
        model.view.el.style.display = 'none';
      }
    },
    handleUpdateStyle(model, editor) {
      const cssComposer = editor.CssComposer;
      let classes = model.getClasses();
      const hidden = model.getStyle().display === 'none';

      let oldStyle =
        cssComposer.getClassRule(classes[0]) && cssComposer.getClassRule(classes[0]).attributes
          ? cssComposer.getClassRule(classes[0]).attributes.style
          : {};

      setTimeout(() => {
        cssComposer.setClassRule(classes[0], {});
        cssComposer.setClassRule(classes[0], { ...oldStyle, display: hidden ? 'none' : 'initial' });
      }, 100);
    },
    handleLocalStorage() {
      const gjsComponent = JSON.parse(localStorage.getItem('gjs-components'));

      if (!(gjsComponent && gjsComponent.length > 0)) {
        return;
      }
      let gjsCSS = localStorage.getItem('gjs-css');

      const components = gjsComponent.map(c => {
        if (c.style.display === 'none') {
          const id = c.attributes.id;
          c.style = {};
          gjsCSS = gjsCSS.replace(`#${id}{display:none;}`, '');
        }
        return c;
      });

      localStorage.setItem('gjs-components', JSON.stringify(components));
      localStorage.setItem('gjs-css', gjsCSS);
    },
    eventStorageEndLoad(editor) {
      editor.on('storage:end:load', function(e) {
        console.log('storage:end:store', e);
      });
    },
    eventStorageStore(editor) {
      editor.on('storage:store', function(e) {
        console.log('storage:store', e);
      });
    },
    eventComponentDeSelected(editor) {
      editor.on('component:deselected', (some, argument) => {
        console.log('component:deselected', some);
      });
      var iconSave = document.querySelector('.icon-save');
      iconSave.classList.add('icon-selected');
      this.setShowIconSave(true);
    },
    eventCommandRun(editor) {
      editor.on('undo', (some, argument) => {
        var iconSave = document.querySelector('.icon-save');
        iconSave.classList.add('icon-selected');
        this.setShowIconSave(true);
      });
      editor.on('redo', (some, argument) => {
        var iconSave = document.querySelector('.icon-save');
        iconSave.classList.add('icon-selected');
        this.setShowIconSave(true);
      });
    },
    updateSelectedComponent(editor, getCurrentSlide) {
      const wrapper = editor.DomComponents.getWrapper();
      //editor.setComponents(getCurrentSlide.html);
      let components = getCurrentSlide.components
        ? getCurrentSlide.components.replace(/"contenteditable":true/g, '"contenteditable":false')
        : '{}';
      let settings = document.querySelector('.gjs-toolbar');
      settings.style.display = 'block';
      editor.setComponents(JSON.parse(components));

      /*
       *       TODO
       *       The two lines above should be replaced by
       *       editor.setStyle(getCurrentSlide.styles || getCurrentSlide.css);
       *       After Updating to the last version of grapes
       */
      editor.setStyle(getCurrentSlide.style);
      editor.setStyle(getCurrentSlide.css);
      localStorage.setItem('gjs-js', getCurrentSlide.js);
      wrapper.set('style', '');
      if (
        getCurrentSlide &&
        getCurrentSlide.options &&
        document.querySelector('#selected-element-properties input')
      ) {
        document.querySelector('#selected-element-properties input').value = this.SecToTime(
          getCurrentSlide.options.duration,
        );
      }
      try {
        editor.select(editor.DomComponents.getWrapper());
      } catch (e) {}
      if (getCurrentSlide.type === 'images') {
        this.updateWrapperProperties(editor, getCurrentSlide.src, null, getCurrentSlide.type);
      } else {
        this.updateWrapperProperties(editor);
      }
      // Re-anchor the screen background onto the wrapper from the stored CSS.
      // updateWrapperProperties relies on getComputedStyle(body).backgroundImage,
      // which can read back 'none' right after setStyle (before the rule paints) and
      // is also independent of whether the image has loaded. When that happens the
      // background-image never gets written onto the wrapper's own style, so the next
      // getCss() drops it and the screen is saved blank (lost on edit -> re-save).
      // Reading the declarations straight from getCurrentSlide.css is deterministic.
      this.anchorBodyBackground(editor, getCurrentSlide.css);
    },
    anchorBodyBackground(editor, css) {
      if (!css || typeof css !== 'string') return;
      const bodyRule = css.match(/body\s*\{([^}]*)\}/i);
      if (!bodyRule) return;
      const bg = {};
      bodyRule[1].split(';').forEach(decl => {
        const idx = decl.indexOf(':');
        if (idx === -1) return;
        const prop = decl.slice(0, idx).trim().toLowerCase();
        const value = decl.slice(idx + 1).trim();
        if (prop.indexOf('background') === 0 && value) bg[prop] = value;
      });
      const img = bg['background-image'];
      if (!img || img === 'none') return;
      try {
        editor.DomComponents.getWrapper().addStyle(bg);
      } catch (e) {}
    },
    updateWrapperProperties(editor, imageSrc, color, type) {
      // Background Color

      if (color) {
        this.$root.$emit('oldBackgroundColor', color);
      }
      let classe = '';
      let cssComposer = editor.CssComposer;
      var selected = editor.getSelected();
      let typeSelected = selected.attributes.type;
      const iframe = document.querySelector('iframe').contentWindow;
      let css = '';
      let element = iframe.document.body;

      if (typeSelected == 'custom_column') {
        element = selected.view.el;
        classe = selected.view.el.classList[0];

        css = cssComposer.getClassRule(classe);
      }
      const bodyStyle = window.getComputedStyle(element);

      const wrapper = editor.getWrapper();
      let bgColor = color || bodyStyle.backgroundColor;
      let backgImage = bodyStyle.backgroundImage;
      // bgColor = bgColor === 'rgb(255, 255, 255)' ? 'initial' : bgColor;
      selected.addStyle({ 'background-color': bgColor });

      const colorPickerEl = document.querySelector(
        '#gjs-sm-background-color .gjs-field-color-picker',
      );
      const colorInputEl = document.querySelector(
        '#gjs-sm-background-color .gjs-input-holder input',
      );

      if (colorPickerEl && colorInputEl) {
        colorPickerEl.style.backgroundColor = bgColor;
        colorInputEl.value = bgColor;
        if (typeSelected === 'custom_column') {
          const newId = 'i' + generateClass().substr(1);
          let attributes = editor.getSelected().getAttributes();
          attributes = attributes ? attributes : {};
          attributes.id = newId;
          editor.getSelected().setAttributes(attributes);
          let oldStyle1 = css && css.attributes ? css.attributes.style : {};
          let newStyle1 = Object.assign({}, oldStyle1, { 'background-color': bgColor });
          cssComposer.setIdRule(newId, newStyle1);
          //selected.addStyle(newStyle1);
        }
      }

      if (imageSrc) {
        backgImage = "url('" + imageSrc + "')";
      }
      if (backgImage !== 'none' && backgImage.slice(-6, -2) !== 'none') {
        // Background Image
        document.querySelectorAll('#gjs-sm-close-layer').forEach(e => {
          e.click();
        });
        document.querySelector('#gjs-sm-background #gjs-sm-add').click();
        let style = {};

        if (typeSelected !== 'custom_column') {
          Object.keys(bodyStyle)
            .filter(
              k =>
                bodyStyle[k].indexOf('background') > -1 &&
                bodyStyle[k] !== 'backgroundColor' &&
                bodyStyle[k] !== 'background' &&
                bodyStyle[k],
            )
            .forEach(k => {
              const key = bodyStyle[k]
                .split(/(?=[A-Z])/)
                .join('-')
                .toLowerCase();
              style[key] = bodyStyle.getPropertyValue(bodyStyle[k]);

              let bgProperty = key + '-' + bodyStyle[k];
              if (key === 'background-position-x') {
                bgProperty += ' ' + bodyStyle['background-position-y'];
              }
              const bgPropertyEl = document.getElementById(bgProperty);

              if (bgPropertyEl) {
                bgPropertyEl.click();
              }
            });
        }
        let styleCss = { 'background-image': backgImage };
        if (type === 'images') {
          styleCss = {
            'background-image': backgImage,
            'background-repeat': 'no-repeat',
            'background-position': '100%',
            'background-size': 'cover',
          };
        }
        let newStyle = Object.assign({}, style, styleCss);

        if (typeSelected === 'custom_column') {
          let oldStyle = css && css.attributes ? css.attributes.style : {};
          let newStyle = Object.assign({}, oldStyle, styleCss);
          cssComposer.setClassRule(classe, newStyle);
          selected.addStyle(newStyle);
        } else {
          wrapper.addStyle(newStyle);
        }

        document.getElementById('gjs-sm-preview-file').style.backgroundImage = backgImage;
      }
    },
    eventColorPickerListener() {
      const iframe = document.querySelector('iframe').contentWindow;
      const colorPickerEl = document.querySelector(
        '#gjs-sm-background-color .gjs-field-color-picker',
      );
      const colorInputEl = document.querySelector(
        '#gjs-sm-background-color .gjs-input-holder input',
      );

      if (!colorPickerEl) {
        setTimeout(() => {
          this.eventColorPickerListener();
        }, 1000);
        return;
      }

      colorPickerEl.addEventListener('click', () => {
        const bodyStyle = window.getComputedStyle(iframe.document.body);
        const bgColor = bodyStyle.backgroundColor;
        const colorThumbsEl = document.querySelectorAll('.sp-thumb-el');

        if (colorPickerEl && colorInputEl) {
          if (colorThumbsEl) {
            colorThumbsEl.forEach(thumb => {
              const thumbEl = thumb.querySelector('.sp-thumb-inner');
              if (thumbEl.style.backgroundColor === bgColor) {
                thumb.click();
              }
            });
          }
        }
      });
    },

    updateColorSvg(selectedEl, color) {
      let self = this;
      var invocation = new XMLHttpRequest();
      if (invocation != null) {
        invocation.open('GET', selectedEl.get('src'), true);
        invocation.onreadystatechange = handler;
        invocation.send();
      }
      function handler(evtXHR) {
        if (invocation.readyState === 4) {
          if (invocation.status === 200) {
            //success
            let textSVG = invocation.response;
            if (textSVG) {
              var htmlObject = document.createElement('div');
              htmlObject.innerHTML = textSVG;
              let svgTag = htmlObject.querySelector('svg');
              let allFill = svgTag.querySelectorAll('[fill]');
              let allStrock = svgTag.querySelectorAll('[stroke]');
              if (allStrock) {
                allStrock.forEach(e => {
                  e.attributes.stroke.value = color;
                });
              }
              if (allFill) {
                allFill.forEach(e => {
                  e.attributes.fill.value = color;
                });
              }
              let svg64 = window.btoa(new XMLSerializer().serializeToString(svgTag));
              let newSrc64 = 'data:image/svg+xml;base64,' + svg64;
              selectedEl.set('src', newSrc64);
              selectedEl.view.iframe.src = newSrc64;
            }
          } else {
            console.log('failure');
          }
        }
      }
    },
    addDefaultColors(editor, type, color) {
      let colors = color ? color : this.paramsClient.default_colors;
      if (!colors) {
        return;
      }
      const self = this;
      const cssComposer = editor.CssComposer;
      const backgroundProps = document.querySelector(`#gjs-sm-${type} .gjs-sm-properties`);

      const styleType = type === 'text' ? 'color' : 'background-color';
      const typeEl = document.querySelector(`#gjs-sm-${type}`);
      if (!(typeEl && backgroundProps)) {
        setTimeout(() => {
          this.addDefaultColors(editor, type);
        }, 1000);
        return;
      }
      typeEl.classList.add('hide-picker');
      let old = document.querySelector('#gjs-sm-recent-colors-' + type);
      if (old) {
        old.parentNode.removeChild(old);
      }
      const props = document.createElement('div');
      props.className = 'gjs-sm-property gjs-sm-radio';
      props.id = 'gjs-sm-recent-colors-' + type;

      const labelEl = document.createElement('div');
      labelEl.innerHTML = `
        <div class="gjs-sm-label">
          <span class="gjs-sm-icon">
            Couleurs par défaut
          </span>
        </div>`;

      const fieldsEl = document.createElement('div');
      fieldsEl.className = 'gjs-field gjs-field-radio';

      const radioItemEl = document.createElement('div');
      radioItemEl.className = 'gjs-radio-items';

      colors.forEach(color => {
        if (color.value && color.value === 'transparent' && type === 'text') {
          return;
        }
        const colorEl = document.createElement('div');
        colorEl.className = 'gjs-radio-item';

        const inputEl = document.createElement('input');
        inputEl.className = 'gjs-sm-radio';
        inputEl.value = color.value;

        const labelEl = document.createElement('label');

        if (color.value && color.value === 'transparent')
          labelEl.className = 'gjs-sm-icon gjs-radio-item-label gjs-radio-item-label-transparent';
        else labelEl.className = 'gjs-sm-icon gjs-radio-item-label';
        labelEl.style.backgroundColor = color.value;
        labelEl.setAttribute('title', color.name || color.value);

        colorEl.appendChild(inputEl);
        colorEl.appendChild(labelEl);

        radioItemEl.appendChild(colorEl);

        labelEl.addEventListener('click', function() {
          const selectedEl = editor.getSelected();
          if (selectedEl.get('type') === 'custom_column') {
            self.updateWrapperProperties(editor, null, this.style.backgroundColor);
            selectedEl.set('style', { [styleType]: this.style.backgroundColor });
          } else if (selectedEl.get('type') === 'wrapper') {
            self.updateWrapperProperties(editor, null, this.style.backgroundColor);
            selectedEl.set('style', { [styleType]: this.style.backgroundColor });
          } else if (
            selectedEl.get('type') === 'image_media' ||
            selectedEl.get('type') === 'pattern'
          ) {
            self.updateColorSvg(selectedEl, this.style.backgroundColor);
          } else {
            const classes = selectedEl.getAttributes().class.split(' ');
            if (classes && classes[0]) {
              const oldStyle = cssComposer.getClassRule(classes[0]).attributes.style;
              const newStyle = Object.assign({}, oldStyle, {
                [styleType]: this.style.backgroundColor,
              });
              cssComposer.setClassRule(classes[0], newStyle);
            }
          }
        });
      });

      fieldsEl.appendChild(radioItemEl);
      props.appendChild(labelEl);
      props.appendChild(fieldsEl);
      backgroundProps.prepend(props);
    },

    eventRunPreview(editor) {
      editor.on('run:preview', model => {
        let elem = document.getElementById('gjs');
        if (elem.requestFullscreen) {
          elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) {
          /* Firefox */
          elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) {
          /* Chrome, Safari & Opera */
          elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) {
          /* IE/Edge */
          elem.msRequestFullscreen();
        }
        this.getSelectedSlides('fullScreen');
        //this.setAutoplayPlayer(editor);
        this.setNoMutedVideo();
      });
    },
    eventStopPreview(editor) {
      editor.on('stop:preview', model => {
        try {
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
          }
          // this.setNoAutoplayVideo(editor);
          let videoPlayers = ['video', 'player', 'playlist'];
          videoPlayers.forEach(player => {
            // this.setPausedVideo(player);
          });
          //this.setMutedVideo(model);
        } catch (e) {
          console.log('eventStopPreview', e);
        }
      });
    },
    eventComponentAdd(editor) {
      let self = this;
      editor.on('canvas:dragover', (e, argument) => {
        const left = Math.max(e.clientX, 0);
        const top = Math.max(e.clientY, 0);
        window.dragLeft = left;
        window.dragTop = top;
      });

      editor.on('canvas:dragend', (e, argument) => {});
      editor.on('component:add', (some, argument) => {
        var iconSave = document.querySelector('.icon-save');
        if (iconSave) {
          iconSave.classList.add('icon-selected');
          self.setShowIconSave(true);
        }

        let compPlayers = ['player', 'playlist', 'live', 'video_mp4'];
        let compImages = ['image', 'image_media' || 'pattern'];
        if (
          compPlayers.indexOf(some.attributes.type) > -1 ||
          compImages.indexOf(some.attributes.type) > -1
        ) {
          let type;
          if (compPlayers.indexOf(some.attributes.type) > -1) {
            type = 'video';
          }

          if (compImages.indexOf(some.attributes.type) > -1) {
            type = 'image';
          }
          self.translatePluginsTitle(some.attributes.type, type);
        }
        if (some.attributes.type === 'video_mp4') {
          // this.setCurrentSlide(Object.assign({}, this.currentSlide, { fullscreenVideo: true }));
        }
        if (some.attributes.type === 'social_media') {
          let type = 'social-media';
          self.translatePluginsTitle(some.attributes.type, type);
        }

        let cssComposer = editor.CssComposer;
        let iframe = document.querySelector('.gjs-frame').contentWindow;
        const wrapper = iframe.document.querySelector('#wrapper');
        let id = self.generateId();
        if (!!!some.getAttributes().id) {
          some.set('attributes', { id });
        }
        if (
          some.attributes.type === 'linkedin_widget' ||
          some.attributes.type === 'clocks' ||
          some.attributes.type === 'dateHeure'
        ) {
          if (!!!some.getAttributes().class) {
            some.set('attributes', {
              class: self.generateId(),
            });
          }
        }
        if (some.attributes.type === 'text' || some.attributes.type === 'link') {
          let modelClass = self.generateId();
          let exist = some.getAttributes()['data-class'] || some.getAttributes().class;
          let newClass = exist;
          if (exist === 'custom-title' || exist === 'custom-sharing') {
            if (some.getAttributes().class) {
              newClass = some.getAttributes().class;
              if (some.getAttributes().class === exist) {
                newClass = modelClass;
              }
            }
            some.addAttributes({
              'data-class': exist,
              class: newClass,
            });
          } else if (exist === 'custom-credit') {
            if (some.getAttributes().class) {
              newClass = some.getAttributes().class;
              if (some.getAttributes().class === exist) {
                newClass = modelClass;
              }
            }
            some.addAttributes({
              'data-class': exist,
              'data-rotation': 'vertical',
              class: newClass,
            });
          } else {
            some.addAttributes({
              'emp-data-class': 'emp-' + some.attributes.type,
            });
          }
          if (self.paramsClient.display_fonts && self.paramsClient.display_fonts.length > 0) {
            let classes = some.getClasses();
            let fonts = self.paramsClient.display_fonts;
            let custom = [
              {
                value: `Din Regular`,
                name: `Din Regular`,
              },
              {
                value: `Din bold`,
                name: `Din bold`,
              },
            ];
            let exist = some.getAttributes()['data-class'];
            let style;

            let cssComposer = editor.CssComposer;
            let css = cssComposer.getClassRule(classes[0]);
            if (classes && classes[0]) {
              let oldStyle =
                cssComposer.getClassRule(classes[0]) &&
                cssComposer.getClassRule(classes[0]).attributes
                  ? cssComposer.getClassRule(classes[0]).attributes.style
                  : {};

              var styleFamilyFont = oldStyle['font-family'];
              var newStyleFamilyFont = oldStyle['new-font-family'];
              let newFont = styleFamilyFont;
              if (
                styleFamilyFont === undefined ||
                styleFamilyFont === fonts[0].value ||
                styleFamilyFont === custom[0].value
              ) {
                if (exist) {
                  newFont = custom[0].value;
                } else {
                  newFont = fonts[0].value;
                }
                style = {
                  'font-family': newFont,
                  'new-font-family': newFont,
                };
              } else {
                style = {
                  'font-family': styleFamilyFont,
                  'new-font-family': newStyleFamilyFont,
                };
              }
              let newStyle = Object.assign(oldStyle, style);
              cssComposer.setClassRule(classes[0], newStyle);
            }
          }
        }

        if (some.attributes.name === 'Row') {
          some.attributes.components.models.forEach(m => {
            m.set('attributes', { id: self.generateId() });
          });
        }
        let compIframes = ['social_media', 'image_media', 'pattern'];
        if (compIframes.indexOf(some.attributes.type) > -1) {
          let id;
          if (some.attributes.type === 'image_media') {
            id = 'image-media';
          }
          if (some.attributes.type === 'social_media') {
            id = 'social-media';
          }
          if (some.attributes.type === 'pattern') {
            id = 'pattern';
          }
          setTimeout(() => {
            let iframe = document.getElementById(id + '-iframe');
            if (iframe.style.display === 'block') {
              editor.select(some);
            }
          }, 500);
        }

        if (some.attributes.type === 'map') {
          editor.setStyle({
            selectors: [some.cid],
            style: { width: '100%', height: '25%' },
          });
        }

        if (some.attributes.type === 'video') {
          let cssComposer = editor.CssComposer;
          let classes = some.getClasses();
          if (classes && classes[0]) {
            let oldStyle =
              cssComposer.getClassRule(classes[0]) &&
              cssComposer.getClassRule(classes[0]).attributes
                ? cssComposer.getClassRule(classes[0]).attributes.style
                : {};
            let newStyle = Object.assign(oldStyle, {
              width: '30%',
              height: '30%',
              'background-color': 'black',
            });
            cssComposer.setClassRule(classes[0], newStyle);
          }
        }
        if (some.attributes.type === 'custom-countdown') {
          let classess = some.getClasses();
          if (classess[0] === 'countdown') {
            some.set('attributes', { class: self.generateId() });
          }

          let cssComposer = editor.CssComposer;
          let classes = some.getClasses();
          if (classes && classes[0]) {
            let oldStyle =
              cssComposer.getClassRule(classes[0]) &&
              cssComposer.getClassRule(classes[0]).attributes
                ? cssComposer.getClassRule(classes[0]).attributes.style
                : {};
            let styleAdded = {
              width: oldStyle.width ? oldStyle.width : '30%',
              height: oldStyle.height ? oldStyle.height : '15%',
              'font-size': oldStyle['font-size'] ? oldStyle['font-size'] : '1.5vw',
            };
            if (classes && classes[0]) {
              let newStyle = Object.assign({}, oldStyle, styleAdded);
              cssComposer.setClassRule(classes[0], newStyle);
            }
            let oldStyleDigit =
              cssComposer.getClassRule('countdown-digit') &&
              cssComposer.getClassRule('countdown-digit').attributes
                ? cssComposer.getClassRule('countdown-digit').attributes.style
                : {};
            let oldStyleLabel =
              cssComposer.getClassRule('countdown-label') &&
              cssComposer.getClassRule('countdown-label').attributes
                ? cssComposer.getClassRule('countdown-label').attributes.style
                : {};
            let newStyleDigit = Object.assign(
              {
                padding: '0.4em',
                'border-radius': '0.2em',
                'background-color': '#dedede',
                color: 'inherit',
                'font-size': '1.6em',
                'text-align': 'center',
              },
              oldStyleDigit,
            );
            let newStyleLabel = Object.assign(
              { color: 'inherit', top: '0px', margin: '0.5em 0.2em 0 0.5em', 'font-size': '0.7em' },
              oldStyleLabel,
            );

            cssComposer.setClassRule('countdown-digit', newStyleDigit);
            cssComposer.setClassRule('countdown-label', newStyleLabel);
          }
          some.view.updateScript();
          localStorage.setItem('gjs-js', editor.getJs());
        }
        if (some.attributes.tagName === 'blockquote') {
          let cssComposer = editor.CssComposer;
          let classes = some.getClasses();
          if (classes && classes[0]) {
            let oldStyle =
              cssComposer.getClassRule(classes[0]) &&
              cssComposer.getClassRule(classes[0]).attributes
                ? cssComposer.getClassRule(classes[0]).attributes.style
                : {};
            let newStyle = Object.assign({}, oldStyle);

            if (!!!newStyle['font-style']) {
              newStyle = Object.assign(
                {
                  color: '#777',
                  'font-weight': '300',
                  padding: '10px',
                  'box-shadow': '-5px 0 0 0 #ccc',
                  'font-style': 'italic',
                  margin: '20px 30px',
                },
                newStyle,
              );
              cssComposer.setClassRule(classes[0], newStyle);
            }
          }
        }

        if (some.attributes.type == 'filet') {
          let classes = some.getClasses();
          if (classes && classes[0]) {
            const iframe = document.querySelector('.gjs-frame');
            let el = some.view.el;
            const { width, height } = el.getBoundingClientRect();
            let top =
              Math.max(((window.dragTop - height / 2) / iframe.offsetHeight) * 100, 0) + '%';
            let style = { top };
            let newStyle;
            let oldStyle =
              cssComposer.getClassRule(classes[0]) &&
              cssComposer.getClassRule(classes[0]).attributes
                ? cssComposer.getClassRule(classes[0]).attributes.style
                : {};
            newStyle = Object.assign({}, style, oldStyle);
            cssComposer.setClassRule(classes[0], newStyle);
          }
        }

        if (some.attributes.type === 'text') {
          let cssComposer = editor.CssComposer;
          let classes = some.getClasses();
          if (classes && classes[0]) {
            let oldStyle =
              cssComposer.getClassRule(classes[0]) &&
              cssComposer.getClassRule(classes[0]).attributes
                ? cssComposer.getClassRule(classes[0]).attributes.style
                : {};
            let newStyle = Object.assign(
              { 'font-family': 'Arial, Helvetica, sans-serif' },
              oldStyle,
            );
            cssComposer.setClassRule(classes[0], newStyle);
          }
        }
        let componentsArray = [
          'text',
          'link',
          'image',
          'image_media',
          'social_media',
          'video',
          'player',
          'video_mp4',
          'playlist',
          'live',
          'webrtc',
          'custom-countdown',
          'rss_widget',
          'web_widget',
          'social-icons-weather',
          'clocks',
          'facebook_widget',
          'social-icons-twitter',
          'characters',
          'texts',
          'shapes',
          'dateHeure',
        ];
        let classes = some.getClasses();
        let models = editor.DomComponents.getComponents().models;
        if (componentsArray.indexOf(some.attributes.type) > -1) {
          if (classes && classes[0]) {
            let style = {
              position: 'fixed',
              'z-index': models.length,
            };
            let newStyle;
            let oldStyle =
              cssComposer.getClassRule(classes[0]) &&
              cssComposer.getClassRule(classes[0]).attributes
                ? cssComposer.getClassRule(classes[0]).attributes.style
                : {};
            newStyle = Object.assign({}, style, oldStyle);
            cssComposer.setClassRule(classes[0], newStyle);
          }
          let oldStyle =
            cssComposer.getClassRule(classes[0]) && cssComposer.getClassRule(classes[0]).attributes
              ? cssComposer.getClassRule(classes[0]).attributes.style
              : {};
          if ((!oldStyle.left && !oldStyle.top) || (!oldStyle.left && !oldStyle.bottom)) {
            const iframe = document.querySelector('.gjs-frame');
            let el = some.view.el;
            const { width, height } = el.getBoundingClientRect();
            let left =
              Math.max(((window.dragLeft - width / 2) / iframe.offsetWidth) * 100, 0) + '%';
            let top =
              Math.max(((window.dragTop - height / 2) / iframe.offsetHeight) * 100, 0) + '%';
            let bottom =
              Math.max(100 - ((window.dragTop - height / 2) / iframe.offsetHeight) * 100, 0) + '%';

            // custom credit
            let style = {};
            let exist = some.attributes.attributes['data-class'];
            if (exist && exist === 'custom-credit') {
              left = '0%';
              bottom = '1%';
              style = {
                left,
                bottom,
              };
            } else {
              style = {
                left,
                top,
              };
            }

            let s = Object.assign({}, oldStyle, style);
            cssComposer.setClassRule(classes[0], s);

            /*const toolbar = document.querySelector('.gjs-rte-toolbar');
            toolbar.style.top = window.dragTop - height / 2 - 38 + 15 + 'px';
            toolbar.style.left =
              window.dragLeft - width / 2 + iframe.getBoundingClientRect().left + 'px';*/
          }
        }
      });
    },
    ckEditorsUpdated(exist) {
      let linkckEditors = { name: 'links', groups: ['links', 'Unlinks'] };
      let ckeditors = storage_init.pluginsOpts['gjs-plugin-ckeditor'];
      let toolbarGroups = ckeditors.options.toolbarGroups;
      let removed = [];
      let extraPluginsArray = [];
      let extraPlugins = ckeditors.options['extraPlugins'];
      for (let index = 0; index < toolbarGroups.length; index++) {
        if (toolbarGroups[index].name === 'links') {
          removed = toolbarGroups.splice(index, 1);
          index--;
        }
      }
      extraPluginsArray = extraPlugins.split(',');
      if (extraPluginsArray.indexOf('lineheight') === -1) {
        extraPluginsArray.push('lineheight');
      }

      if (exist === 'custom-title' || exist === 'custom-sharing' || exist === 'custom-credit') {
        for (let i = 0; i < extraPluginsArray.length; i++) {
          if (extraPluginsArray[i] === 'lineheight') {
            extraPluginsArray.splice(i, 1);
          }
        }
        if (exist === 'custom-sharing') {
          if (toolbarGroups.indexOf(linkckEditors) === -1) {
            toolbarGroups.push(linkckEditors);
          }
        }
      }
      extraPlugins = extraPluginsArray.toString();
      ckeditors.options['extraPlugins'] = extraPlugins;
    },
    eventComponentStyleAlign(editor) {
      editor.on('component:styleUpdate:float', model => {
        if (window.floatPressed) {
          return;
        }

        window.floatPressed = true;
        setTimeout(() => {
          window.floatPressed = false;
        }, 200);

        const cssComposer = editor.CssComposer;
        let classes = model.getClasses();
        const id = model.getAttributes().id;
        const iframeEl = document.querySelector('.gjs-frame');

        const iframeWidth = iframeEl.getBoundingClientRect().width;
        const modelWidth = model.view.el.getBoundingClientRect().width;
        const modelLeft = model.view.el.getBoundingClientRect().left;

        const leftEl = Math.max(modelLeft / iframeWidth, 0) * 100;
        const rightEl = Math.max(1 - (modelLeft + modelWidth) / iframeWidth, 0) * 100;

        let oldStyleClass =
          cssComposer.getClassRule(classes[0]) && cssComposer.getClassRule(classes[0]).attributes
            ? cssComposer.getClassRule(classes[0]).attributes.style
            : {};

        const oldStyleId = cssComposer.getIdRule(id)
          ? cssComposer.getIdRule(id).attributes.style
          : {};

        const styleAttribute = {};
        const isImage =
          model.get('type') === 'image' ||
          model.get('type') === 'image_media' ||
          model.get('type') === 'social_media';
        if (isImage) {
          styleAttribute.left = oldStyleClass.left;
        }

        const { float } = oldStyleClass;

        let newStyleId = {};
        let newStyleClass = {};

        if (
          !float ||
          (float === 'left' && leftEl < rightEl) ||
          (float === 'right' && rightEl < leftEl)
        ) {
          return;
        }

        if (float === 'none') {
          const oldLeft = oldStyleId.oldLeft || oldStyleClass.oldLeft;
          newStyleId = Object.assign({}, oldStyleId, { left: oldLeft, right: 'auto' });
          newStyleClass = Object.assign({}, oldStyleClass, { left: oldLeft, right: 'auto' });
        } else if (float === 'right') {
          newStyleId = Object.assign({}, oldStyleId, {
            left: 'auto',
            right: leftEl + '%',
          });
          newStyleClass = Object.assign({}, oldStyleClass);
        } else if (float === 'left') {
          newStyleId = Object.assign({}, oldStyleId, {
            left: rightEl + '%',
            right: 'auto',
          });
          newStyleClass = Object.assign({}, oldStyleClass);
        }

        if (isImage) {
          model.view.el.setAttribute('style', '');
          cssComposer.setClassRule(classes[0], { ...newStyleClass, ...newStyleId });
        } else {
          cssComposer.setIdRule(id, newStyleId);
          cssComposer.setClassRule(classes[0], newStyleClass);
        }
      });
    },
    eventComponentUpdateImage(editor) {
      let self = this;
      editor.on('component:update:src', (model, argument) => {
        if (model.attributes.type === 'image') {
          var srcImage = model.attributes.src;
          if (srcImage.indexOf('/mini/') !== -1) {
            var srcImageOrigin = srcImage.replace('/mini/', '/');
            srcImage = srcImageOrigin;
            model.attributes.src = srcImage;
            model.attributes.attributes.src = srcImage;
            model.view.el.src = srcImage;
            getImageSize(srcImage);
          } else {
            getImageSize(srcImage);
          }
          // noinspection JSAnnotator
          function getImageSize(url) {
            var img = new Image();
            var width = 0;
            img.onload = function() {
              width = img.width;
              window.eventHub.$emit('updateWidthImage', { className: model.getClasses()[0], img });
            };
            img.src = url;
            return img.width;
          }
        }
      });
      editor.on('stop:open-assets', function(e, f, v, c) {
        const getAllComponents = (model, result = []) => {
          result.push(model);
          model.components().each(mod => getAllComponents(mod, result));
          return result;
        };
        const all = getAllComponents(editor.DomComponents.getWrapper());

        for (var i = 0; i < all.length; i++) {
          let type = all[i].attributes.type;
          let src = all[i].attributes.src;
          if (type === 'image') {
            if (!src) {
              grapesjsEMP.editors[0].UndoManager.undo();
            }
          }
        }
      });
    },
    async eventComponentCloneElement(editor) {
      let cssComposer = editor.CssComposer;
      let self = this;
      editor.on('component:clone', (some, argument, e) => {
        var iconSave = document.querySelector('.icon-save');
        if (iconSave) {
          iconSave.classList.add('icon-selected');
          this.setShowIconSave(true);
        }
        const selectedEl = editor.getSelected();
        const conpounedTypes = ['social-icons-twitter', 'clocks', 'dateHeure'];
        if (
          conpounedTypes.indexOf(selectedEl.attributes.type > -1) &&
          selectedEl.attributes.type !== some.attributes.type
        ) {
          return;
        }
        let modelId = self.generateId();
        let modelClass = self.generateId();
        some.set('attributes', { id: modelId });
        let positionLeft;
        let positionTop;
        let zIndex;
        let left = 2;
        let top = 2;
        let newStyle;
        if (some.attributes.copyable) {
          let id = selectedEl.getAttributes().id;
          let oldClass = selectedEl.getAttributes().class;
          let newClass = '';

          let dataId = { oldid: id, newid: modelId };
          self.duplicateSvgObject(dataId);
          /**/
          let exist = selectedEl.getAttributes()['data-class'];
          if (
            exist &&
            (exist === 'custom-title' || exist === 'custom-sharing' || exist === 'custom-credit')
          ) {
            if (oldClass) {
              newClass = { class: oldClass };
            }
            some.addAttributes({
              'data-class': exist,
              newClass,
            });
          }

          if (cssComposer.getIdRule(id)) {
            let oldStyle = cssComposer.getIdRule(id).attributes.style;
            cssComposer.setIdRule(modelId, oldStyle);
            let position = oldStyle.position;
            positionLeft = oldStyle.left;
            positionTop = oldStyle.top;
            zIndex = parseInt(oldStyle['z-index']);
            let obj = { position: position, left: left + '%', top: top + '%' };
            if (positionLeft && positionTop) {
              var posLeft = parseInt(positionLeft) + 2 + '%';
              var posTop = parseInt(positionTop) + 2 + '%';
              if (some.attributes.type === 'filet') {
                posLeft = '50%';
                posTop = parseInt(positionTop) + 10 + '%';
              }
              obj.left = posLeft;
              obj.top = posTop;
              newStyle = Object.assign({}, oldStyle, obj);
            }
            if (!isNaN(zIndex)) {
              obj = Object.assign({}, obj, { 'z-index': zIndex + 1 });
            }
            cssComposer.setIdRule(modelId, obj);
          } else if (cssComposer.getClassRule(oldClass)) {
            let oldStyle = cssComposer.getClassRule(oldClass).attributes.style;
            cssComposer.setClassRule(modelClass, oldStyle);
            let position = oldStyle.position;
            positionLeft = oldStyle.left;
            positionTop = oldStyle.top;
            zIndex = parseInt(oldStyle['z-index']);
            let obj = { position: position, left: left + '%', top: top + '%' };
            if (positionLeft && positionTop) {
              var posLeft = parseInt(positionLeft) + 2 + '%';
              var posTop = parseInt(positionTop) + 2 + '%';
              if (some.attributes.type === 'filet') {
                posLeft = '50%';
                posTop = parseInt(positionTop) + 10 + '%';
              }
              obj.left = posLeft;
              obj.top = posTop;
              newStyle = Object.assign({}, oldStyle, obj);
            }
            if (!isNaN(zIndex)) {
              obj = Object.assign({}, obj, { 'z-index': zIndex + 1 });
            }
            cssComposer.setClassRule(modelClass, obj);
          }
          let classes = editor.getSelected().getAttributes().class;
          if (classes) {
            classes = classes.split(' ');
            if (classes && classes[0]) {
              let oldStyle =
                cssComposer.getClassRule(classes[0]) &&
                cssComposer.getClassRule(classes[0]).attributes
                  ? cssComposer.getClassRule(classes[0]).attributes.style
                  : {};
              let position = oldStyle.position;
              positionLeft = oldStyle.left;
              positionTop = oldStyle.top;

              let obj = { left: left + '%', top: top + '%' };
              if (oldStyle.position === 'absolute' || oldStyle.position === 'fixed') {
                if (positionLeft && positionTop) {
                  var posLeft = parseInt(positionLeft) + 2 + '%';
                  var posTop = parseInt(positionTop) + 2 + '%';
                  if (some.attributes.type === 'filet') {
                    posLeft = '50%';
                    posTop = parseInt(positionTop) + 10 + '%';
                  }
                  obj.left = posLeft;
                  obj.top = posTop;
                }
                newStyle = Object.assign({}, oldStyle, obj);
              } else {
                newStyle = Object.assign({}, obj, oldStyle);
              }
              if (!isNaN(zIndex)) {
                newStyle = Object.assign({}, newStyle, { 'z-index': zIndex + 1 });
              }
              some.removeClass(classes[0]);
              some.addClass(modelClass);

              cssComposer.setClassRule(modelClass, newStyle);
            }
          }
          self.setNoAutoplayDuplicateVideo(editor, modelId);
          if (some.attributes.type === 'image' || some.attributes.type === 'image_media') {
            some.attributes.attributes.src = some.attributes.src;
          }
          if (some.attributes.type === 'text' || some.attributes.type === 'link') {
            if (self.paramsClient.display_fonts && self.paramsClient.display_fonts.length > 0) {
              let classes = some.getClasses();

              let cssComposer = editor.CssComposer;
              let css = cssComposer.getClassRule(classes[0]);
              if (classes && classes[0]) {
                let oldStyle =
                  cssComposer.getClassRule(classes[0]) &&
                  cssComposer.getClassRule(classes[0]).attributes
                    ? cssComposer.getClassRule(classes[0]).attributes.style
                    : {};
                var oldStyleFamilyFont = oldStyle['font-family'];
                let newStyle = Object.assign(oldStyle, {
                  'font-family': oldStyleFamilyFont,
                });
                cssComposer.setClassRule(classes[0], newStyle);
              }
            }
          }
          if (some.attributes.type === 'video') {
            let isvideoAutoplay = selectedEl.attributes.autoplay;
            let srcVideo = selectedEl.attributes.src;
            let muted = selectedEl.attributes.muted;
            let extension = srcVideo.split('.').pop();
            if (extension.indexOf('mp4') > -1) {
              selectedEl.addAttributes({
                autoplay: isvideoAutoplay,
                muted: muted,
              });
              some.addAttributes({
                autoplay: isvideoAutoplay,
                muted: muted,
              });
              self.getSourceVideo(srcVideo, isvideoAutoplay, some, some.attributes.type);
            }
          }
          if (some.attributes.type === 'clocks') {
            some.set('copied', true);
            setTimeout(() => {
              some.set('copied', false);
            }, 100);
          }
        }

        setTimeout(() => {
          editor.select(editor.DomComponents.getWrapper());
        }, 100);
      });
    },
    eventDelete(editor) {
      var self = this;
      editor.Keymaps.remove('core:component-delete');
      editor.Keymaps.add('emp:component-delete', 'delete', 'emp-delete');

      editor.Commands.add('emp-delete', ed => {
        const model = Object.assign({}, ed.getSelected());
        if (!model || (model && model.attributes && model.attributes.type === 'text')) {
          return;
        }
        editor.UndoManager.undo();
        self.toastDelete(editor);
      });
      editor.Commands.add('tlb-delete', ed => {
        self.toastDelete(editor);
      });
    },
    eventFullScreen(editor) {
      editor.Commands.add('fullscreen', ed => {});
    },
    eventImageAdded(editor) {
      let self = this;
      let cssComposer = editor.CssComposer;
      editor.on('component:add', (some, argument) => {
        if (some.attributes.type === 'image' || some.attributes.type === 'image_media') {
          let classElement = some.getAttributes().class;
          if (classElement) {
            let classElementFirst = classElement.split(' ')[0];

            if (classElementFirst && some.parent()) {
              let id = some.parent().getAttributes().id;
              var offsetWidth = some.parent().view.el.offsetWidth;
              self.setParentWidth(offsetWidth);

              var someImage = {
                className: classElementFirst,
                idParent: id,
              };
              self.setSomeImage(someImage);
            }
          }

          if (!some.view.el.src) {
            // some.view.el.src =
            //   'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3R5bGU9ImZpbGw6IHJnYmEoMCwwLDAsMC4xNSk7IHRyYW5zZm9ybTogc2NhbGUoMC43NSkiPgogICAgICAgIDxwYXRoIGQ9Ik04LjUgMTMuNWwyLjUgMyAzLjUtNC41IDQuNSA2SDVtMTYgMVY1YTIgMiAwIDAgMC0yLTJINWMtMS4xIDAtMiAuOS0yIDJ2MTRjMCAxLjEuOSAyIDIgMmgxNGMxLjEgMCAyLS45IDItMnoiPjwvcGF0aD4KICAgICAgPC9zdmc+';
            // editor.UndoManager.undo();
          }
        }
      });
    },
    eventClockAdded(editor) {
      editor.on('component:add', (some, argument) => {
        if (some.attributes.type === 'clocks') {
          let cssComposer = editor.CssComposer;
          let classes = some.getClasses();

          let oldStyle =
            cssComposer.getClassRule(classes[0]) && cssComposer.getClassRule(classes[0]).attributes
              ? cssComposer.getClassRule(classes[0]).attributes.style
              : {};

          let styleAdded = {
            width: oldStyle.width ? oldStyle.width : '20%',
            height: oldStyle.height ? oldStyle.height : 'auto',
            'font-size': oldStyle['font-size'] ? oldStyle['font-size'] : '1vw',
          };
          if (classes && classes[0]) {
            let newStyle = Object.assign({}, oldStyle, styleAdded);
            cssComposer.setClassRule(classes[0], newStyle);
          }
          some.view.updateScript();
          localStorage.setItem('gjs-js', editor.getJs());
        }
      });
    },
    eventDateHeureAdded(editor) {
      editor.on('component:add', (some, argument) => {
        if (some.attributes.type === 'dateHeure') {
          let cssComposer = editor.CssComposer;
          let classes = some.getClasses();

          let oldStyle =
            cssComposer.getClassRule(classes[0]) && cssComposer.getClassRule(classes[0]).attributes
              ? cssComposer.getClassRule(classes[0]).attributes.style
              : {};

          let styleAdded = {
            width: oldStyle.width ? oldStyle.width : 'auto%',
            height: oldStyle.height ? oldStyle.height : 'auto',
            'font-size': oldStyle['font-size'] ? oldStyle['font-size'] : '2.1vw',
          };
          if (classes && classes[0]) {
            let newStyle = Object.assign({}, oldStyle, styleAdded);
            cssComposer.setClassRule(classes[0], newStyle);
          }
          some.view.updateScript();
          localStorage.setItem('gjs-js', editor.getJs());
        }
      });
    },

    addSettingButton(editor) {
      if (editor) {
        var selected = editor.getSelected();
        var tb = [];
        let type = selected.get('type');
        let attributes = selected.getAttributes();
        if (type === 'text' && attributes['data-class'] === 'custom-credit') {
          if (selected.get('removable')) {
            selected.set('resizable', false);
            tb.push({
              attributes: { class: 'fa fa-undo', title: 'Rotate' },
              command: 'rotate-element',
            });
            // }
          }
        }
        if (type === 'image_media' || type === 'pattern') {
          /*let src =
            type === 'image' ? selected.attributes.attributes.src : selected.view.el.firstChild.src;
          let extension = src.split('.').pop();
          if ((extension && extension === 'svg') || selected.attributes.svg === 'svg') {
            selected.set('svg', 'svg');*/
          if (selected.get('removable')) {
            tb.push({
              attributes: { class: 'fa fa-object-group', title: 'svg mator' },
              command: 'show-svg-mator',
            });
            // }
          }
        }
        if (selected.collection && selected.collection.parent) {
          // tb.push({
          //   attributes: { class: 'fa fa-arrow-up', title: 'Sélectionner parent' },
          //   command: 'select-parent'
          // });
        } else if (
          selected.attributes.type === 'wrapper' &&
          this.hasPermission('edit_duration_segment_action')
        ) {
          tb.push({
            attributes: { class: 'fa fa-cogs', title: "Paramètres de l'écran" },
            command: 'screen-settings',
          });
        }
        let classElementFirst;
        if (selected.attributes.type === '') {
          var classCountDown = selected
            .parent()
            .parent()
            .getAttributes().class;
          if (classCountDown) {
            classElementFirst = classCountDown;
          }
        }

        if (
          selected.get('copyable') &&
          !selected.getAttributes()['data-js'] &&
          !classElementFirst
        ) {
          tb.push({
            attributes: this.setDuplicateAttr,
            command: 'tlb-clone',
          });
        }
        if (
          selected.get('removable') &&
          !selected.getAttributes()['data-js'] &&
          !classElementFirst
        ) {
          tb.push({
            attributes: this.setRemoveAttr,
            command: 'tlb-delete',
          });
        }

        if (selected.get('removable')) {
          tb.push({
            attributes: this.setEditAttr,
            command: 'show-editor',
          });
        }
        if (
          selected.get('removable') &&
          !selected.getAttributes()['data-js'] &&
          !classElementFirst
        ) {
          tb.push({
            attributes: this.setSettingsAttr,
            command: 'show-setting',
          });
        }

        let delay = selected.getAttributes().value;
        if (delay) {
          this.setDelayFragment(delay);
          this.$root.$emit('change-delay', delay);
        } else {
          this.$root.$emit('change-delay', '');
          this.setDelayFragment('');
        }
        let attributeElement = selected.getAttributes();
        if (selected && attributeElement) {
          let classElement = selected.getAttributes().class;
          if (classElement) {
            let classElementFirst = classElement.split(' ')[0];
            if (classElementFirst) {
              var elemnt = '.' + classElementFirst + ' ';
              let element = document
                .querySelector('.gjs-frame')
                .contentWindow.document.querySelector(elemnt);
              if (element && selected) {
                let style = getComputedStyle(element);
                if (style) {
                  var opacityElement = style.opacity;
                  this.setOpacityFragment(opacityElement * 100);
                  this.$root.$emit('change-opacity', opacityElement * 100);
                } else {
                  this.$root.$emit('change-opacity', 100);
                  this.setOpacityFragment(100);
                }
              }
            }
          }
        }
        if (type === 'video_mp4') {
          tb.push({
            attributes: { class: 'fa fa-arrows-alt', title: 'FullScreen' },
            command: 'full-screen-video',
          });
        }

        /*
        if(type ==="image_media"){
          tb.push({
            attributes: { class: 'icon-expand-in full-BG BG-icon', title: 'Arrière plan' },
            command: 'full-background-img',
          });
        }

        if(type==="wrapper"){
          tb=[];
          tb.push({
            attributes: { class: 'icon-resize-out reset-full-BG BG-icon', title: 'Réinitialiser arrière plan' },
            command: 'reset-full-background-img',
          });

        }
         */
        if (
          selected.get('draggable') &&
          (this.paramsClient.isDisplayVideo !== null &&
            this.paramsClient.isDisplayVideo &&
            !selected.getAttributes()['data-js'] &&
            !classElementFirst)
        ) {
          tb.push({
            attributes: {
              class: 'fa fa-arrows',
              title: 'Déplacement libre',
              draggable: true,
            },
            command: 'emp-move',
          });
        } else if (
          selected.get('draggable') &&
          !selected.getAttributes()['data-js'] &&
          !classElementFirst
        ) {
          tb.push({
            attributes: this.setMoveAttr,
            command: 'tlb-move',
          });
        }
        selected.set('toolbar', tb);

        if (
          selected.attributes.type === 'custom_column' ||
          selected.attributes.type === 'video_mp4'
        ) {
          tb = [];
          selected.set('toolbar', tb);
        }
        if (selected.attributes.type === 'custom_column2') {
          tb = [];
          tb.push({
            attributes: this.setRemoveAttr,
            command: 'tlb-delete',
          });
          selected.set('toolbar', tb);
        }
      }
    },
    eventComponentStyleUpdateImageHeightOrWidht(editor) {
      let self = this;
      let styleBusy = { clocks: false, countdown: false };
      let fontBusy = { clocks: false, countdown: false };

      editor.on('component:styleUpdate:height component:styleUpdate:width', model => {
        if (
          model.attributes.type === 'image' ||
          model.attributes.type === 'image_media' ||
          model.attributes.type === 'pattern'
        ) {
          let classes = model.getClasses();
          let cssComposer = editor.CssComposer;
          let css = cssComposer.getClassRule(classes[0]);
          if (classes && classes[0]) {
            let oldStyle = css && css.attributes ? css.attributes.style : {};
            let heightModel =
              oldStyle.height && oldStyle.height !== 'auto'
                ? oldStyle.height
                : window.getComputedStyle(model.view.el).height;
            let widthModel = oldStyle.width
              ? oldStyle.width
              : window.getComputedStyle(model.view.el).width;

            const iframeEl = document.querySelector('.gjs-cv-canvas .gjs-frame');
            if (heightModel.indexOf('px') > -1 || heightModel.indexOf('%') === -1) {
              let h = isNaN(parseFloat(heightModel))
                ? parseFloat(window.getComputedStyle(model.view.el).height)
                : parseFloat(heightModel);

              const height = (h / parseFloat(window.getComputedStyle(iframeEl).height)) * 100 + '%';
              let newStyle = Object.assign({}, oldStyle, { height });
              cssComposer.setClassRule(classes[0], newStyle);
            }
            if (widthModel.indexOf('px') > -1 || widthModel.indexOf('%') === -1) {
              let w = isNaN(parseFloat(widthModel))
                ? parseFloat(window.getComputedStyle(model.view.el).width)
                : parseFloat(widthModel);

              const width = (w / parseFloat(window.getComputedStyle(iframeEl).width)) * 100 + '%';
              let newStyle = Object.assign({}, oldStyle, { width });
              cssComposer.setClassRule(classes[0], newStyle);
            }
          }
        }

        if (model.attributes.type === 'text') {
          let classes = model.getClasses();
          let cssComposer = editor.CssComposer;
          let css = cssComposer.getClassRule(classes[0]);
          if (classes && classes[0]) {
            let oldStyle = css && css.attributes ? css.attributes.style : {};
            let heightModel =
              oldStyle.height && oldStyle.height !== 'auto'
                ? oldStyle.height
                : window.getComputedStyle(model.view.el).height;

            let widthModel = oldStyle.width
              ? oldStyle.width
              : window.getComputedStyle(model.view.el).width;

            const iframeEl = document.querySelector('.gjs-cv-canvas .gjs-frame');
            if (heightModel.indexOf('px') > -1) {
              const height =
                (parseFloat(heightModel) / parseFloat(window.getComputedStyle(iframeEl).height)) *
                  100 +
                '%';
              let newStyle = Object.assign({}, oldStyle, { height });
              cssComposer.setClassRule(classes[0], newStyle);
            }
            if (widthModel.indexOf('px') > -1) {
              const width =
                (parseFloat(widthModel) / parseFloat(window.getComputedStyle(iframeEl).width)) *
                  100 +
                '%';
              let newStyle = Object.assign({}, oldStyle, { width });
              cssComposer.setClassRule(classes[0], newStyle);
            }
          }
          self.updateEditableTextHeightWidth(editor);
        }
        const type = model.attributes.type;
        if (type === 'countdown' && !styleBusy[type]) {
          // || type === 'clocks'
          styleBusy[type] = true;
          setTimeout(() => {
            styleBusy[type] = false;
            this.udpdateClocksWidthHeight(editor, model);
            setTimeout(() => {
              if (!styleBusy[type]) {
                let classes = model.getClasses();
                let cssComposer = editor.CssComposer;
                let css = cssComposer.getClassRule(classes[0]);
                if (classes && classes[0]) {
                  let oldStyle = css && css.attributes ? css.attributes.style : {};
                  let newStyle = Object.assign({}, oldStyle, { height: 'auto' });
                  cssComposer.setClassRule(classes[0], newStyle);
                }
              }
            }, 300);
          }, 100);
          this.udpdateClocksWidthHeight(editor, model);
        }

        if (model.attributes.type === 'linkedin_widget') {
          let classes = model.getClasses();
          let cssComposer = editor.CssComposer;
          let css = cssComposer.getClassRule(classes[0]);

          if (classes && classes[0]) {
            let oldStyle = css && css.attributes ? css.attributes.style : {};
            let heightModel = oldStyle.height
              ? oldStyle.height
              : window.getComputedStyle(model.view.el).height;

            let widthModel = oldStyle.width
              ? oldStyle.width
              : window.getComputedStyle(model.view.el).width;

            const iframeEl = document.querySelector('.gjs-cv-canvas .gjs-frame');

            if (heightModel.indexOf('px') > -1) {
              const height =
                (parseFloat(heightModel) / parseFloat(window.getComputedStyle(iframeEl).height)) *
                  100 +
                '%';
              let newStyle = Object.assign({}, oldStyle, { height });
              cssComposer.setClassRule(classes[0], newStyle);
            }
            if (widthModel.indexOf('px') > -1) {
              const width =
                (parseFloat(widthModel) / parseFloat(window.getComputedStyle(iframeEl).width)) *
                  100 +
                '%';
              let newStyle = Object.assign({}, oldStyle, { width });
              cssComposer.setClassRule(classes[0], newStyle);
            }
          }
        }

        if (
          model.attributes.type === 'linkedin_widget' ||
          model.attributes.type === 'facebook_widget' ||
          model.attributes.type === 'social-icons-twitter'
        ) {
          let classes = model.getClasses();
          let cssComposer = editor.CssComposer;
          let css = cssComposer.getClassRule(classes[0]);

          if (classes && classes[0]) {
            let oldStyle = css && css.attributes ? css.attributes.style : {};
            let heightModel = oldStyle.height
              ? oldStyle.height
              : window.getComputedStyle(model.view.el).height;

            let widthModel = oldStyle.width
              ? oldStyle.width
              : window.getComputedStyle(model.view.el).width;

            const iframeEl = document.querySelector('.gjs-cv-canvas .gjs-frame');

            if (heightModel.indexOf('px') > -1) {
              const height =
                (parseFloat(heightModel) / parseFloat(window.getComputedStyle(iframeEl).height)) *
                  100 +
                '%';
              let newStyle = Object.assign({}, oldStyle, { height });
              cssComposer.setClassRule(classes[0], newStyle);
            }
            if (widthModel.indexOf('px') > -1) {
              const width =
                (parseFloat(widthModel) / parseFloat(window.getComputedStyle(iframeEl).width)) *
                  100 +
                '%';
              let newStyle = Object.assign({}, oldStyle, { width });
              cssComposer.setClassRule(classes[0], newStyle);
            }
            if (model.attributes.type === 'facebook_widget') {
              model.view.updateScript();
              localStorage.setItem('gjs-js', editor.getJs());
            }
          }
        }
      });

      editor.on('component:styleUpdate:font-size', model => {
        const type = model.get('type');
        if ((type === 'custom-countdown' || type === 'clocks') && !fontBusy[type]) {
          // || type === 'clocks'
          fontBusy[type] = true;
          setTimeout(() => {
            fontBusy[type] = false;
            this.udpdateClocksFontSize(editor, model);
          }, 100);
          this.udpdateClocksFontSize(editor, model);
        }
      });
    },
    eventComponentStyleUpdate(editor) {
      editor.on('component:styleUpdate', model => {
        const wrapper = document.getElementsByClassName('gjs-frame')[0];
        if (wrapper) {
          wrapper.contentDocument.all[2].style.overflow = 'hidden';
        }
        //editor.CssComposer.clear();
        //var model = editor.getSelected();

        var iconSave = document.querySelector('.icon-save');
        if (iconSave) {
          iconSave.classList.add('icon-selected');
          this.setShowIconSave(true);
        }
      });
    },
    eventComponentUpdate(editor) {
      editor.on('component:update', e => {
        /* var iconSave = document.querySelector('.icon-save');
          if (iconSave) {
              iconSave.classList.add('icon-selected');
          }*/
        this.updateCustomColumn(editor, e);
        this.updateToolbarPosition();
      });
    },
    updateCustomColumn(editor, model) {
      if (model && model.attributes && model.attributes.type == 'custom_column') {
        if (
          model.attributes.style &&
          model.attributes.style['background-image'] &&
          model.attributes.style['background-image'] !== 'none'
        ) {
          let selected = editor.getSelected();
          if (selected && selected.attributes.getClasses()[0] == model.attributes.getClasses()[0]) {
            let oldStyle = selected.view.el ? selected.view.el.getComputedStyle() : {};
            let newStyle = Object.assign({}, model.attributes.style, oldStyle);
            newStyle['background-image'] =
              oldStyle['background-image'].indexOf('none') > 0
                ? model.attributes.style['background-image']
                : oldStyle['background-image'];
            newStyle['background-repeat'] =
              oldStyle['background-repeat'] === 'row'
                ? model.attributes.style['background-repeat']
                : oldStyle['background-repeat'];
            newStyle['background-position'] =
              oldStyle['background-position'] === 'row'
                ? model.attributes.style['background-position']
                : oldStyle['background-position'];
            newStyle['background-size'] =
              oldStyle['background-size'] === 'row'
                ? model.attributes.style['background-size']
                : oldStyle['background-size'];
            selected.addStyle(newStyle);
          }
        }
      }
    },
    eventComponentUpdateWidthSrc(editor) {
      editor.on(
        'component:styleUpdate:height component:styleUpdate:width component:update:src',
        model => {
          const modelEl = JSON.parse(JSON.stringify(model.view.el.getBoundingClientRect()));
          const iframeEl = JSON.parse(
            JSON.stringify(document.querySelector('.gjs-frame').getBoundingClientRect()),
          );
          const margin = 10;
          /*if (
            (model.get('type') === 'player' || model.get('type') === 'video_mp4') &&
            ((modelEl.left <= margin && modelEl.width + margin >= iframeEl.width) ||
              (modelEl.top <= margin && modelEl.height + margin >= iframeEl.height))
          ) {
            if (this.$route.name !== 'segment') {
              this.updateSegmentDuration({
                duration: model.attributes.duration,
                uid: this.currentSlide.uid,
                fullscreenVideo: true,
                originalDuration: model.attributes.duration,
              });
              if (!window.selected) {
                this.handleIsMultipleBy30Segment(this.currentSlide.uid, model.attributes.duration);
              }
            } else {
              this.updateSlideDuration({
                duration: model.attributes.duration,
                uid: this.currentSlide.uid,
              });
            }
          }*/
          if (model.get('type') === 'clocks') {
            this.udpdateClocksWidthHeight(editor, model);
          }
        },
      );
    },
    eventComponentUpdateStyleBackgroundImage(editor) {
      editor.on('component:styleUpdate:background-image', e => {
        if (e && e.attributes && e.attributes.style['background-image']) {
          var srcImage = e.attributes.style['background-image'];
          if (srcImage.indexOf('/mini/')) {
            srcImage = srcImage.replace('/mini/', '/');
            e.attributes.style['background-image'] = srcImage;
            e.view.el.style['background-image'] = srcImage;
          }
        }
      });
    },
    updateToolbarPosition() {
      setTimeout(() => {
        const canvasEl = document.querySelector('.gjs-frame');
        const toolbarEl = document.querySelector('.gjs-toolbar');

        const canvas = canvasEl.getBoundingClientRect();
        const toolbar = toolbarEl.getBoundingClientRect();

        const { width, height, left, top } = canvas;
        if (toolbar.left + toolbar.width > left + width) {
          toolbarEl.style.left = left + width - toolbar.width + 'px';
        }
        if (toolbar.top + toolbar.height > height + 15) {
          toolbarEl.style.top = height + 15 - toolbar.height + 'px';
        }
      }, 100);
    },
    timeToSec(time) {
      try {
        const sec = time
          .split(':')
          .reverse()
          .reduce((prev, curr, i) => prev + curr * Math.pow(60, i), 0);
        return isNaN(sec) ? 5 : sec;
      } catch (e) {
        console.log('catch timeToSec', time);
      }
      return time;
    },
    SecToTime(seconds) {
      const sec = parseInt(seconds, 10);
      if (isNaN(sec)) {
        return '00:00:20';
      }
      var h = Math.floor(sec / 3600);
      var m = Math.floor((sec - h * 3600) / 60);
      var s = sec - h * 3600 - m * 60;

      if (h < 10) {
        h = '0' + h;
      }
      if (m < 10) {
        m = '0' + m;
      }
      if (s < 10) {
        s = '0' + s;
      }
      return h + ':' + m + ':' + s;
    },
    setDeviceManagerEditor(editor, getParamsClients) {
      let self = this;
      if (
        getParamsClients.display_devices !== null ||
        Object.keys(getParamsClients.display_devices).length > 0
      ) {
        let devices = getParamsClients.display_devices.map(device => {
          return device.name;
        });
        let classNames = getParamsClients.display_devices.map(item => {
          return item.className;
        });
        let sizeX = getParamsClients.display_devices.map(item => {
          return item.x;
        });
        let sizeY = getParamsClients.display_devices.map(item => {
          return item.y;
        });
        let Height = getParamsClients.display_devices.map(item => {
          return item.height;
        });
        let Width = getParamsClients.display_devices.map(item => {
          return item.width;
        });
        devices.forEach((device, index) => {
          for (let i = 0; i < device.length; i++) {
            editor.DeviceManager.add('pc-' + device, Width, {
              height: Height,
              widthMedia: '', // the width that will be used for the CSS media
            });
          }
        });
      }
    },
    updateActiveDevice(model) {
      model.collection.deactivateAll(model.get('context'), model);
      model.set('active', true, { silent: true }).trigger('checkActive');
    },
    setDeviceEditor(editor, getParamsClients) {
      let self = this;
      let devices = getParamsClients.display_devices.map(device => {
        return device.name;
      });
      let classNames = getParamsClients.display_devices.map(item => {
        return item.className;
      });
      let sizeX = getParamsClients.display_devices.map(item => {
        return item.x;
      });
      let sizeY = getParamsClients.display_devices.map(item => {
        return item.y;
      });
      var buttons = [];
      devices.forEach((device, index) => {
        var buttonsPanel = Object.assign({});

        buttonsPanel.position = 'barista';
        buttons.push({
          id: 'set-pc-' + device,
          className: classNames[index],
          active: true,
          command: 'device-' + device,
        });
      });
      editor.Panels.addPanel({
        id: 'devices-b',
        visible: true,

        buttons: buttons,
      });
      devices.forEach((device, index) => {
        editor.Commands.add('device-' + device, {
          run: function(editor, Model, sender) {
            editor.setDevice('pc-' + device);
            self.setDeviceType(device);
            let size = {
              x: sizeX[index],
              y: sizeY[index],
            };
            self.setDeviceSize(size);
            self.updateCanvasDimensions();
            self.updateActiveDevice(Model);

            if (sender) {
              sender.sender.set('active', true);
            }
          },
          stop: function(editor, sender) {},
        });
      });

      editor.Panels.removePanel('devices-c');
      editor.on('load', function() {
        editor.Panels.getButton('views', 'open-blocks').set('active', true);
        editor.setDevice('pc-landscape');
      });
    },
    eventComponentUpdateCountDown(editor) {
      let self = this;
      let busy = { clocks: false, countdown: false, dateHeure: false };
      editor.on(
        'component:update:startfrom component:update:endText component:styleUpdate component:update',
        function(model) {
          const type = model.get('type');
          if (
            (type === 'custom-countdown' || type === 'clocks' || type === 'dateHeure') &&
            !busy[type]
          ) {
            busy[type] = true;
            setTimeout(() => {
              busy[type] = false;
            }, 1000);

            model.view.updateScript();
            localStorage.setItem('gjs-js', editor.getJs());
            let localStorageComponents = JSON.parse(localStorage.getItem('gjs-components')).map(
              item => {
                if (item.attributes.id === model.getAttributes().id) {
                  item = model;
                }
                return item;
              },
            );
            localStorage.setItem('gjs-components', JSON.stringify(localStorageComponents));
          }
        },
      );
    },
    eventEditText(editor) {
      if (typeof jQuery === 'undefined') {
        return;
      }
      let self = this;
      const iframeBody = editor.Canvas.getBody();
      let settings = document.querySelector('.gjs-toolbar');

      $(iframeBody).on('focus', '[contenteditable="true"]', function(e) {
        settings.style.display = 'none';
      });

      $(iframeBody).on('keyup', '[contenteditable="true"]', function(e) {
        self.updateEditableTextHeightWidth(editor);
        settings.style.display = 'none';
      });
    },

    updateEditableTextHeight(editor) {
      editor.on('component:styleUpdate:width', model => {
        if (model.attributes.type !== 'text') {
          return;
        }
        const id = model.getAttributes().id;
        const cssComposer = editor.CssComposer;

        let classes = model.getClasses();
        let oldStyle =
          cssComposer.getClassRule(classes[0]) && cssComposer.getClassRule(classes[0]).attributes
            ? cssComposer.getClassRule(classes[0]).attributes.style
            : {};

        const iframeEl = document.querySelector('.gjs-frame');
        const el = iframeEl.contentWindow.document.getElementById(id);

        let newStyle = Object.assign({}, oldStyle, { height: 'auto' });
        cssComposer.setClassRule(classes[0], newStyle);
      });
    },
    updateEditableTextHeightWidth(editor) {
      const model = editor.getSelected();
      const id = model.getAttributes().id;
      const cssComposer = editor.CssComposer;

      let classes = model.getClasses();
      let oldStyle =
        cssComposer.getClassRule(classes[0]) && cssComposer.getClassRule(classes[0]).attributes
          ? cssComposer.getClassRule(classes[0]).attributes.style
          : {};

      const iframeEl = document.querySelector('.gjs-frame');
      const el = iframeEl.contentWindow.document.getElementById(id);
      const iframeHeight = parseFloat(window.getComputedStyle(iframeEl).height);
      const iframeWidth = parseFloat(window.getComputedStyle(iframeEl).width);

      if (el.scrollHeight > el.offsetHeight || el.scrollWidth > el.offsetWidth) {
        let height = (el.scrollHeight / iframeHeight) * 100 + '%';
        let width = (el.scrollWidth / iframeWidth) * 100 + '%';
        let newStyle = Object.assign({}, oldStyle, { height, width });
        cssComposer.setClassRule(classes[0], newStyle);
      }

      const resizer = document.querySelector('.gjs-resizer-c');
      const elHeight = el.getBoundingClientRect().height;
      const elWidth = el.getBoundingClientRect().width;
      if (resizer) {
        resizer.style.height = elHeight + 'px';
        resizer.style.width = elWidth + 'px';
      }
    },
    eventDragEnd(editor) {
      editor.on('component:add', (model, argument) => {
        if (model.attributes.type === 'image') {
          this.renderAssets(editor);
        }
      });
      editor.on('run:open-assets', () => {
        this.renderAssets(editor);
      });
    },
    renderAssets(editor) {
      const am = editor.AssetManager;

      setTimeout(() => {
        scrollPage = 20;
        am.render(am.getAll().filter((a, i) => i < scrollPage));
        const assetsWrapper = document.querySelector('.gjs-am-assets');
        let loading = false;
        if (assetsWrapper) {
          if (scrollPage === 20) {
            am.render(am.getAll().filter((a, i) => i < scrollPage));
          }
          assetsWrapper.addEventListener('scroll', e => {
            if (
              assetsWrapper.scrollTop + assetsWrapper.offsetHeight >= assetsWrapper.scrollHeight &&
              !loading
            ) {
              loading = true;
              scrollPage += 20;
              am.render(am.getAll().filter((a, i) => i < scrollPage));
            } else {
              loading = false;
            }
          });
        }
      }, 100);
    },

    eventPausedPlayer(editor) {
      editor.on(
        'component:add component:update:src component:update:autoplay ',
        (model, argument) => {
          let videoArray = ['video', 'player', 'video_mp4', 'playlist'];
          let attrAutoplay;
          if (videoArray.indexOf(model.attributes.type) > -1) {
            let srcVideoOrigin;
            this.srcVideo = model.attributes.src;
            if (this.srcVideo && this.srcVideo !== null) {
              let extension = this.srcVideo.split('.').pop();
              if (
                model.attributes.type === 'video' ||
                model.attributes.type.indexOf('video') > -1
              ) {
                attrAutoplay = 'autoplay';
                this.handleVideo(model);
              } else {
                attrAutoplay = 'a';
                this.setPausedVideo(model.attributes.type);
              }
              if (extension.indexOf('mp4') === -1) {
                if (this.srcVideo.indexOf(attrAutoplay + '=1') === -1) {
                  this.isvideoAutoplayed = 0;
                }
                if (this.srcVideo.indexOf(attrAutoplay + '=1') > -1) {
                  this.isvideoAutoplayed = 1;
                }
              }
              srcVideoOrigin = this.srcVideo;
              this.getSourceVideo(srcVideoOrigin, this.isvideoAutoplayed, model, videoArray);
            }
          }
        },
      );
    },
    handleVideo(model) {
      this.srcVideo = model.attributes.src;
      let extension = this.srcVideo.split('.').pop();
      if (extension.indexOf('mp4') === -1) {
        this.setNotMp4Players(model);
      } else {
        this.setMp4Players(model);
      }
    },
    setNotMp4Players(model) {
      let attr;
      let videoId = model.attributes.attributes.id;
      let iframe = document.querySelector('.gjs-frame').contentWindow;
      if (this.srcVideo.indexOf('vimeo') > -1) {
        if (this.srcVideo.indexOf('&muted=true') === -1) {
          attr = '&muted=true';
        }
      } else {
        if (this.srcVideo.indexOf('&mute=1') === -1) {
          attr = '&mute=1';
        }
      }
      if (attr) {
        this.srcVideo = this.srcVideo.replace(this.srcVideo, this.srcVideo + attr);
      }
      if (videoId) {
        let videoEl = iframe.document.querySelector('#' + videoId);
        if (videoEl) {
          videoEl.setAttribute('src', this.srcVideo);
        }
      }
    },
    setMp4Players(model) {
      let iframe = document.querySelector('.gjs-frame').contentWindow;
      let videoId = model.attributes.attributes.id;
      let videoElIframe = iframe.document.querySelector('#' + videoId);
      let videoEl = iframe.document.querySelector('#' + videoId + '> video');
      let isAutoplay = model.attributes.autoplay;
      if (videoElIframe) {
        videoElIframe.muted = true;
        if (videoEl) {
          videoEl.muted = true;
        }

        if (isAutoplay !== null && (isAutoplay !== '0' || isAutoplay !== 0 || isAutoplay === '')) {
          this.isvideoAutoplayed = 1;
        } else {
          this.isvideoAutoplayed = 0;
        }

        let obj = {
          autoplay: this.isvideoAutoplayed,
          muted: true,
        };
        model.addAttributes(obj);
      }
    },
    setNoMutedVideo() {
      let slides;
      if (this.$route.name === 'segment' || this.$route.name === 'edit') {
        slides = JSON.parse(JSON.stringify(this.getCurrentSegment));
      } else {
        slides = JSON.parse(JSON.stringify(this.getCurrentSlide));
      }
      return JSON.parse(this.getSanitizedHtml(JSON.stringify(slides.screens[0].html)));
    },

    eventAutoPlayVideo(editor) {
      editor.on('component:update:src', (model, argument) => {
        let isvideoAutoplay = 0;
        let attrAutoplay;
        let videoArray = ['video'];
        if (videoArray.indexOf(model.attributes.type) > -1) {
          var srcVideo = model.attributes.src;
          if (srcVideo && srcVideo !== null) {
            var srcVideoOrigin = srcVideo;
            if (model.attributes.type === 'video') {
              attrAutoplay = 'autoplay';
            } else {
              attrAutoplay = 'a';
            }
            if (srcVideo.indexOf(attrAutoplay + '=1') === -1) {
              isvideoAutoplay = 0;
              srcVideoOrigin = srcVideo;
            }
            if (srcVideo.indexOf(attrAutoplay + '=1') > -1) {
              isvideoAutoplay = 1;
              srcVideo = srcVideo.replace(attrAutoplay + '=1', attrAutoplay + '=0');
              srcVideoOrigin = srcVideo;
            }
            this.getSourceVideo(srcVideoOrigin, isvideoAutoplay, model, videoArray);
          }
        }
      });
    },
    getSourceVideo(srcVideoOrigin, isvideoAutoplay, model, videoArray) {
      let iframe = document.querySelector('.gjs-frame').contentWindow;
      let srcVideo = srcVideoOrigin;
      model.attributes.src = srcVideo;
      model.attributes.attributes.src = srcVideo;
      if (model.view) {
        model.view.el.src = srcVideo;
      }
      model.attributes.autoplay = isvideoAutoplay;
      model.attributes.muted = true;
      let videoId = model.attributes.attributes.id;
      if (videoId) {
        let videoEl = iframe.document.querySelector('#' + videoId);
        let videoElIframe = iframe.document.querySelector('#' + videoId + ' > iframe');
        let iframeVideo = iframe.document.querySelector('#' + videoId + ' > video');
        if (videoEl) {
          videoEl.setAttribute('src', srcVideo);
        }
        if (videoElIframe) {
          videoElIframe.setAttribute('src', srcVideo);
        }

        if (iframeVideo && model.attributes.type.indexOf('video_mp4') === -1) {
          iframeVideo.setAttribute('src', srcVideo);
          iframeVideo.setAttribute('autoplay', isvideoAutoplay);
          iframeVideo.setAttribute('muted', true);
        }
      }
      let comps = JSON.parse(localStorage.getItem('gjs-components'));
      this.updateVideoComponent(model, comps, videoArray, isvideoAutoplay, srcVideo);
    },
    updateVideoComponent(model, comps, videoArray, isvideoAutoplay, srcVideo) {
      let videoId = model.attributes.attributes.id;
      if (comps && Object.keys(comps).length > 0) {
        comps.forEach(comp => {
          if (comp.attributes.id === videoId && videoArray.indexOf(comp.type) > -1) {
            comp.slide = JSON.parse(JSON.stringify(this.getCurrentSlideIndex));
            comp.src = srcVideo;
            comp.attributes.src = srcVideo;
            comp.autoplay = isvideoAutoplay;
            comp.attributes.autoplay = isvideoAutoplay;
            comp.attributes.muted = true;
            this.$root.$emit('isVideoAutoplay', { model: model, video: comp });
          }
        });
      }
    },
    eventSupSelectedText(editor) {
      const rte = editor.RichTextEditor;
      rte.add('Sup', {
        icon: '<sup>2</sup>',
        attributes: { title: 'Sup' },
        result: rte => {
          return rte.insertHTML(`<sup>${rte.selection()}</sup>`);
        },
      });
    },
    handleIsMultipleBy30Segment(uid, durationVid) {
      if (!durationHelper.isMultipleBy30()) {
        return true;
      }
      const segment = this.getSegmentByUid(uid);
      if (segment.duration % 30 === 0) {
        return true;
      }
      /*const fullscreenVideo = segment.screens.find(s => s.fullscreenVideo);
      if (!fullscreenVideo) {
        return false;
      }

      if (durationVid <= 30) {
        this.$root.$emit('eventExtendDuration', { duration: durationVid, uid: segment.uid });
      } else {
        this.$root.$emit('eventExtendSegmentDuration', { uid: segment.uid });
      }
      */
    },
    updatePositionCkeditors(editor) {
      let selected = editor.getSelected();
      let self = this;
      if (selected) {
        if (selected.view.el) {
          selected.view.el.addEventListener('dblclick', function(e) {
            const canvasEl = document.querySelector('.gjs-frame');
            const ckeditorsEl = document.querySelector('.gjs-rte-toolbar');
            setTimeout(() => {
              const canvas = canvasEl.getBoundingClientRect();
              const ckeditor = ckeditorsEl.getBoundingClientRect();
              const { width, height, right, left } = ckeditor;
              if (ckeditor.height > 50) {
                ckeditorsEl.style.right = '45px';
                ckeditorsEl.style.left = 'auto';
              } else {
                ckeditorsEl.style.right = 'auto';
                ckeditorsEl.style.left = left + 'px';
              }
            }, 10);
          });
        }
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/GrapesMixinEditors.js